import { AutoUpdateModel, DeployMethod } from '@/react/portainer/gitops/types';

import { SwitchField } from '@@/form-components/SwitchField';

import { AutoUpdateSettings } from './AutoUpdateSettings';

export function AutoUpdateFieldset({
  value,
  onChange,
  environmentType,
  deployMethod,
  isForcePullVisible = true,
  baseWebhookUrl,
  webhookId,
  webhooksDocs,
}: {
  value: AutoUpdateModel;
  onChange: (value: AutoUpdateModel) => void;
  environmentType?: 'DOCKER' | 'KUBERNETES';
  deployMethod?: DeployMethod;
  isForcePullVisible?: boolean;
  baseWebhookUrl: string;
  webhookId: string;
  webhooksDocs?: string;
}) {
  return (
    <>
      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            name="gitopsWebhook"
            data-cy="gitops-webhook-switch"
            checked={value.RepositoryAutomaticUpdates}
            label="Create a Webhook"
            tooltip="Enable a webhook to trigger an immediate redeployment on demand."
            labelClass="col-sm-3 col-lg-2"
            onChange={(value) =>
              handleChange({ RepositoryAutomaticUpdates: value })
            }
          />
        </div>
      </div>

      {value.RepositoryAutomaticUpdates && (
        <AutoUpdateSettings
          webhookId={webhookId}
          baseWebhookUrl={baseWebhookUrl}
          value={value}
          onChange={handleChange}
          environmentType={environmentType}
          deployMethod={deployMethod}
          showForcePullImage={isForcePullVisible}
          webhookDocs={webhooksDocs}
        />
      )}
    </>
  );

  function handleChange(newValues: Partial<AutoUpdateModel>) {
    onChange({ ...value, ...newValues });
  }
}
